import InnerComponent from '@Components/Sales/EinvoicingEwaybill/EwaybillList/EwaybillForm';
import orgContainer from '@Components/AppContainer';

const EwaybillForm = () => ((orgContainer(InnerComponent)));
export default EwaybillForm;
